import { render, staticRenderFns } from "./ProductionLine.vue?vue&type=template&id=08b0e8dd"
import script from "./ProductionLine.vue?vue&type=script&lang=js"
export * from "./ProductionLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports